<div class="agent-wrapper">
    <div class="agent-avatar">
        <img class="agent-circle" [src]="imageSRC" alt="Claire de SPB Family">
        <span class="agent-online-dot"></span>
    </div>
    <div class="agent-message" ><p [ngClass]="{'padding-90': textPadding == '90-padding'}" [innerHTML]="agentSpeech"></p></div>
</div>
